import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { orgName, orgLogo } from '../selectors/organization';
import { RootState } from '../store';

import { ReactComponent as DefaultTCLogo } from '../images/tc-logo.svg';

import styles from './OrgHeader.module.css';

export function OrgHeader({
  className = styles.header,
  noBorder = false,
  orgLogo,
  orgName,
  scrollToBottom,
}: {
  className?: string;
  noBorder?: boolean;
  orgName: string;
  orgLogo: string;
  scrollToBottom?: () => void;
}) {
  return (
    <div className={classNames(className, noBorder && styles.noBorder)} onClick={scrollToBottom}>
      <div className={styles.headerContainer}>
        {orgLogo ? (
          <div className={styles.headerOrgLogo}>
            <img src={orgLogo} alt={''} />
          </div>
        ) : (
          <div className={styles.headerOrgLogo}>
            <DefaultTCLogo />
          </div>
        )}
        <div className={styles.headerOrgName} aria-label="header-org-name">
          {orgName}
        </div>
        <div className={styles.headerRightPlaceholder} />
      </div>
    </div>
  );
}

const mapState = (state: RootState) => ({
  orgName: orgName(state),
  orgLogo: orgLogo(state),
});

export default connect(mapState)(OrgHeader);
